module.exports = __webpack_public_path__ + "static/img/28.c05054d1.jpeg";